module.exports = __webpack_public_path__ + "static/media/CODE.86005759.png";